import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import UIButton from "../Button/Button";
import { styleType } from "../../../Constants/StyleType";
import UIModal from "../Modal/Modal";
import UIMultiselect from "../Multiselect/Multiselect";
import "./style.css";
import { getWithExpiry } from "../../../Helpers/LocalStorageHelper";
import { postApiCall } from "../../../../Infrastructure/Handlers/HttpHandler";

function UIGameConfigFilter(props) {
    const [modalOpen, setModalOpen] = useState(false);
    const [optionData, setOptionData] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [noResults, setNoResults] = useState(false);

    // Restore saved value and options
    useEffect(() => {
        if (props.savedValue !== undefined && props.savedValue !== null) {
            const val = Array.isArray(props.savedValue)
                ? props.savedValue.join(",")
                : props.savedValue;
            if (val && val.toString().length > 0) {
                setSelectedKeys(val);
            }
        }
        if (props.savedOptions && props.savedOptions.length > 0) {
            setOptionData(props.savedOptions);
        }
    }, [props.savedValue, props.savedOptions]);

    const getElementValue = (id) => {
        if (!id) return null;
        const el = document.getElementById(id);
        return el ? el.value : null;
    };

    const onSearch = async () => {
        setNoResults(false);

        const operatorsRaw = getElementValue(props.operatorId);
        const casinosRaw = getElementValue(props.casinosId);
        const agregatorsRaw = getElementValue(props.agregatorsId);
        const providersRaw = getElementValue(props.providersId);

        const operators = operatorsRaw ? operatorsRaw.split(',').filter(Boolean) : null;
        const casinos = casinosRaw ? casinosRaw.split(',').filter(Boolean) : null;
        const agregators = agregatorsRaw ? agregatorsRaw.split(',').filter(Boolean) : null;
        const providers = providersRaw ? providersRaw.split(',').filter(Boolean) : null;

        const searchEl = document.getElementById("gc-search");
        const searchVal = searchEl ? searchEl.value : "";

        if (!searchVal || searchVal.length === 0) return;

        let token = getWithExpiry("token");
        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        let body = {
            offset: 0,
            limit: 100,
            operators,
            casinos,
            agregators,
            providers,
            searchValues: searchVal,
            columnName: "created_at"
        };

        await postApiCall("game-config/read", body, token).then((result) => {
            let tmpOptions = [];
            optionData.forEach(element => {
                if (selectedKeys.includes(element.id)) {
                    tmpOptions.push(element);
                }
            });
            result.data.data.forEach(element => {
                tmpOptions.push({ id: element.id, name: element.name });
            });
            if (result.data.data.length === 0) {
                setNoResults(true);
            }
            setOptionData(tmpOptions);
        });
    };

    const onConfirm = () => {
        const el = document.getElementById(props.id + "val");
        const value = el ? el.value : "";
        setSelectedKeys(value);

        const count = value ? value.split(",").filter(v => v.trim() !== "").length : 0;
        if (props.onConfirm) {
            props.onConfirm(count, optionData); // pass optionData back to parent
        }

        setModalOpen(false);
        setNoResults(false);
    };

    const isSelected = selectedKeys && selectedKeys.length > 0;

    return (
        <>
            <input type="hidden" name={props.id} id={props.id} value={selectedKeys} />
            <UIButton
                onClick={() => { if (!props.disabled) setModalOpen(true); }}
                buttonText={props.title}
                styleType={isSelected ? styleType.PRIMARY : styleType.LIGHT}
                buttonType={"button"}
                additionalClass={"w-100 mt-2"}
                disabled={props.disabled}
            />

            <UIModal
                showModal={modalOpen}
                onConfirm={onSearch}
                title={props.title}
                confirmButtonText={"SEARCH"}
                body={<>
                    <input type="text" id="gc-search" className={`form-control w-100 mb-2 ${noResults ? "input-error-ui-gc" : ""}`} placeholder="Search..." />
                    <UIMultiselect
                        id={props.id + "val"}
                        options={optionData}
                        displayKey={props.displayKey}
                        getKeyValue={props.id} />
                </>}
                withoutCloseBtn={false}
                onClose={onConfirm}
                closeButtonText={"CONFIRM"}
            />
        </>
    );
}

UIGameConfigFilter.propTypes = {
    title: PropTypes.string,
    id: PropTypes.string,
    displayKey: PropTypes.string,
    onConfirm: PropTypes.func,
    operatorId: PropTypes.string,
    casinosId: PropTypes.string,
    agregatorsId: PropTypes.string,
    providersId: PropTypes.string,
    setLoggedIn: PropTypes.func,
    disabled: PropTypes.bool,
    savedValue: PropTypes.any,
    savedOptions: PropTypes.array,
}

export default UIGameConfigFilter;